import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Layout and Context Providers
import Layout from 'components/layout';
import { BurgerMenuProvider } from 'context/sidebar';
import AuthProvider from 'react-auth-kit/AuthProvider';

// Pages
import Login from './pages/Login';
import SignUp from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import OtpVerification from './pages/OtpVerfication';
import ResetPassword from './pages/ResetPassword';
import Home from 'pages/Home';
import Analytics from 'pages/Analytics';
import Event from './pages/Event';
import CreateEvent from './pages/Event/CreateEvent';
import EditEvent from './pages/Event/EditEvent';
import EventDetails from 'pages/Event/EventDetails';
import EventPreview from 'pages/Event/EventPreview';
import Ticket from './pages/Ticket';
import CreateTicket from 'pages/Ticket/CreateTicket';
import EditTicket from 'pages/Ticket/EditTicket';
import Orders from './pages/Sales/Orders';
import OrderDetails from 'components/Sales/OrderDetails/[id]';
import Package from './pages/Package';
import CreatePackage from './pages/Package/CreatePackage';
import EditPackage from './pages/Package/EditPackage';
import Journey from './pages/Journey';
import CreateJourney from './pages/Journey/CreateJourney';
import EditJourney from './pages/Journey/EditJourney';
import Finance from 'pages/Finance';
import Sales from 'pages/Sales';
import MyAccount from './pages/MyAccount';
import Setting from 'pages/Settings';
import Notifications from 'pages/Notifications';
import Referral from 'pages/Referral';
import ManageAdmins from 'pages/ManageAdmins';
import NotFound from 'pages/NotFoundPage';

// Authentication and Route Protection
import PrivateRoute from 'components/PrivateRoute';
import store from 'store/auth';
import AuthOutlet from '@auth-kit/react-router/AuthOutlet';

function App() {
  return (
    <Router>
      <AuthProvider store={store}>
        <BurgerMenuProvider>
          <Layout>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/otp-verification" element={<OtpVerification />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              {/* Authenticated Routes */}
              <Route element={<AuthOutlet fallbackPath="/" />}>
                {/* Protected Routes */}
                <Route path="/home" element={<PrivateRoute component={<Home />} allowedRoles={['super-admin','admin', 'manager']} />} />
                <Route path="/analytics" element={<PrivateRoute component={<Analytics />} allowedRoles={['super-admin','admin', 'manager']} />} />
                <Route path="/event" element={<PrivateRoute component={<Event />} allowedRoles={['super-admin','admin', 'manager']} />} />
                <Route path="/event/create-event" element={<PrivateRoute component={<CreateEvent />} allowedRoles={['super-admin','admin',]} />} />
                <Route path="/event/edit-event/:event_id" element={<PrivateRoute component={<EditEvent />} allowedRoles={['super-admin','admin',]} />} />
                <Route path="/event/event-details/:event_id" element={<PrivateRoute component={<EventDetails />} allowedRoles={['super-admin','admin', 'manager']} />} />
                <Route path="/event/event-preview/:event_id" element={<PrivateRoute component={<EventPreview />} allowedRoles={['super-admin', 'admin','manager']} />} />
                <Route path="/ticket" element={<PrivateRoute component={<Ticket />} allowedRoles={['super-admin','admin', 'manager']} />} />
                <Route path="/ticket/create-ticket" element={<PrivateRoute component={<CreateTicket />} allowedRoles={['super-admin','admin']} />} />
                <Route path="/ticket/edit-ticket/:ticket_id" element={<PrivateRoute component={<EditTicket />} allowedRoles={['super-admin','admin']} />} />
                <Route path="/my-account" element={<PrivateRoute component={<MyAccount />} allowedRoles={['super-admin', 'admin','manager']} />} />
                <Route path="/setting" element={<PrivateRoute component={<Setting />} allowedRoles={['super-admin','admin']} />} />
                <Route path="/sales" element={<PrivateRoute component={<Sales />} allowedRoles={['super-admin','admin','manager']} />} />
                <Route path="/orders" element={<PrivateRoute component={<Orders />} allowedRoles={['super-admin','admin', 'manager']} />} />
                <Route path="/orders/details/:id" element={<PrivateRoute component={<OrderDetails />} allowedRoles={['super-admin','admin', 'manager']} />} />
                <Route path="/package" element={<PrivateRoute component={<Package />} allowedRoles={['super-admin','admin', 'manager']} />} />
                <Route path="/package/create-package" element={<PrivateRoute component={<CreatePackage />} allowedRoles={['super-admin','admin',]} />} />
                <Route path="/package/edit-package/:package_id" element={<PrivateRoute component={<EditPackage />} allowedRoles={['super-admin','admin',]} />} />

                <Route path="/journey" element={<PrivateRoute component={<Journey />} allowedRoles={['super-admin', 'admin','manager']} />} />
                <Route path="/journey/create-journey" element={<PrivateRoute component={<CreateJourney />} allowedRoles={['super-admin','admin',]} />} />
                <Route path="/journey/edit-journey/:journey_id" element={<PrivateRoute component={<EditJourney />} allowedRoles={['super-admin','admin',]} />} />


                <Route path="/finance" element={<PrivateRoute component={<Finance />} allowedRoles={['super-admin','admin',]} />} />
                <Route path="/notifications" element={<PrivateRoute component={<Notifications />} allowedRoles={['super-admin', 'manager','admin',]} />} />
                <Route path="/referral" element={<PrivateRoute component={<Referral />} allowedRoles={['super-admin','admin',]} />} />
                <Route path="/manage-admins" element={<PrivateRoute component={<ManageAdmins />} allowedRoles={['super-admin']} />} />
              </Route>

              {/* Catch-all route for 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </BurgerMenuProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
